<div dwRow>
    <div dwCol="4">
        <label class="label">Pilexos Booking Cost</label>
        <div class="read-only">
            {{(checkrideRequest.PilexosBookingCost || 0) | currency}}
        </div>
    </div>
    <div dwCol="4" [hidden]="hideDiscount">
        <label class="label">Discount Code</label>
        <input type="text" class="form-control" [(ngModel)]="paymentDiscountCode" />
        <button (click)="applyDiscountCode()" class="btn btn-primary">Apply</button>

        <div *ngIf="paymentDiscountResult"
            [ngClass]="{ 'dw-red': !paymentDiscountResult.IsValid , 'dw-green': paymentDiscountResult.IsValid }">
            {{paymentDiscountResult.Message}}
        </div>
    </div>
    <div dwCol="4" *ngIf="variableContext?.Discounted_Pilexos_Booking_Cost != null">
        <label class="label">Discounted Pilexos Booking Cost</label>
        <div class="read-only">
            {{(variableContext?.Discounted_Pilexos_Booking_Cost || 0) | currency}}
        </div>
    </div>
</div>